import { CognitoUserData } from '../types';

export const getCognitoUserAttribute = (
  data: CognitoUserData,
  name: string
) => {
  if (data.Attributes) {
    return data.Attributes.find((a) => a.Name === name)?.Value;
  }

  if (data.UserAttributes) {
    return data.UserAttributes.find((a) => a.Name === name)?.Value;
  }

  return;
};

export const getCognitoUserAttributes = ({
  account,
  attrs,
}: {
  account?: CognitoUserData;
  attrs: string[];
}) => (account ? attrs.map((a) => getCognitoUserAttribute(account, a)) : []);

export const canVerifyCognitoUser = (account?: CognitoUserData) => {
  if (!account) return false;

  const [
    email_verified,
    email_verification_code,
    email_verification_expiry,
    hubspot_id,
  ] = getCognitoUserAttributes({
    account,
    attrs: [
      'custom:email_verified',
      'custom:email_verify_code',
      'custom:email_verify_expiry',
      'custom:hubspot_id',
    ],
  });

  /** Check that the necessary attributes are set */
  const can_verify_email =
    email_verified === 'false' &&
    !!email_verification_code &&
    !!email_verification_expiry &&
    !!hubspot_id;

  return can_verify_email;
};
